/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

// @flow
import type { Element } from 'react';

import React from 'react';
import { Field, FormGroup } from '#components/pages/Models/Model/support/form/index.js';
import FieldVisibilityToggle from '#components/pages/Models/Model/sections/support/forms/FieldVisibilityToggle/index.js';

type Props = {|
  designCodeYearName: string,
  fieldsByName: Object,
  form: string,
  showDesignCodeYearToggle: boolean,
  showYearOfConstructionToggle: boolean,
  useYearOfConstruction: boolean,
  yearOfConstructionName: string,
|};

const YearOfConstructionOrCodeYear = ({
  designCodeYearName,
  fieldsByName,
  form,
  showDesignCodeYearToggle,
  showYearOfConstructionToggle,
  useYearOfConstruction,
  yearOfConstructionName,
}: Props): Element<typeof FormGroup> => (
  <FormGroup form={form} fields={[yearOfConstructionName, designCodeYearName]}>
    <Field field={fieldsByName[yearOfConstructionName]} />
    <Field field={fieldsByName[designCodeYearName]} />
    {((showDesignCodeYearToggle && useYearOfConstruction) ||
      (showYearOfConstructionToggle && !useYearOfConstruction)) && (
      <FieldVisibilityToggle
        id="yearOrCodeYearToggle"
        form={form}
        on={useYearOfConstruction}
        onFields={[yearOfConstructionName]}
        onText="Use design code?"
        offFields={[designCodeYearName]}
        offText="Use year of construction?"
      />
    )}
  </FormGroup>
);

export default YearOfConstructionOrCodeYear;
